module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ea952837ca442a3d64ab17637b787d36.png";